export default "__VITE_ASSET__D43eIba8__"